import CryptoJS from "crypto-js";

export async function decryptData(encryptedData) {
    const secretKey = process.env.REACT_APP_SESSION_SECRET;
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

    return JSON.parse(decryptedText);
}
